export const environment = {
  production: false,
  defaultLang: 'it',
  apiUrl:
    'https://europe-west3-procedureselettive.cloudfunctions.net/apitest/v0',
  title: 'ENAC - PROCEDURE SELETTIVE - test',
  googleClientId:
    '371458835110-9po1lk1am6m46st771jicrbevhns1mn2.apps.googleusercontent.com',
  googleClientScopes: 'openid profile email',
  firebase: {
    apiKey: 'AIzaSyB_Xr-xWwh69SlqVw7kCnXj0WxZddYlZ00',
    authDomain: 'procedureselettivetest.firebaseapp.com',
    projectId: 'procedureselettive',
  },
};
